/**
 * RISKS.ESTABLISHMENT
 * Consult the only one establishment for the accountRisksSettings
 */
import NavApp from "@/nav/nav.app"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { useEffect } from "react"
import establishmentStore from "@/entities/establishment/model/establishment.store"
import EstablishmentConfig from "@/entities/establishment/ui/EstablishmentConfig"
import EstablishmentClearData from "@/entities/establishment/ui/EstablishmentClearData"
import RiskScales from "@/entities/physical-risk/ui/RiskScales"

function RisksEstablishmentRoute() {
  const dispatch = useAppDispatch()
  const _session = useAppSelector((state) => state._session)
  const activeEstablishment = useAppSelector(establishmentStore.selectors.active)
  const establishments = useAppSelector(establishmentStore.selectors.list)

  useEffect(() => {
    const load = async () => {
      try {
        const activeEstablishmentId = _session.establishmentId ?? activeEstablishment.id
        const establishmentFromStore = establishments.find((x) => x.id === activeEstablishmentId)

        if (establishmentFromStore) {
          dispatch(establishmentStore.actions.setActive(establishmentFromStore))
          return
        }

        const fetchedEstablishments = await dispatch(establishmentStore.thunks.fetchAndSet()).unwrap()
        const establishment =
          fetchedEstablishments.find((x) => x.id === activeEstablishmentId) ?? fetchedEstablishments[0]

        if (establishment) {
          dispatch(establishmentStore.actions.setActive(establishment))
        }
      } catch (error) {
        console.error("Impossible de charger l'établissement :", error)
      }
    }
    load()
  }, [])

  return (
    <NavApp>
      <EstablishmentConfig />
      {_session.risksInterfaceType === "ESTABLISHMENT" && _session.risksRole === "ADMIN" && (
        <>
          <RiskScales />
          <EstablishmentClearData />
        </>
      )}
    </NavApp>
  )
}

export default RisksEstablishmentRoute
